import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const tableHead = [
  "Sr.",
  "Template Name",
  "Template Label",
  "Active Status",
  "Actions",
];

const WhatsAppTemplateSettingTable = ({
  data = [],
  currentPage,
  itemsPerPage,
}) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const goToView = (id) => {
    navigate(`/view-whatsapp-template-setting/${id}`);
  };

  const handleToggleStatus = (item) => {
    let values = {
      isActive: !item.isActive,
    };

    setLoading(true);
    performRequest(
      "PATCH",
      `/whatsAppTemplateSetting/update/${item?.id}`,
      values
    )
      .then((res) => {
        if (res.status === 200) {
          const updatedData = tableData.map((row) =>
            row.id === item.id ? { ...row, isActive: !row.isActive } : row
          );

          setTableData(updatedData);
        } else {
          Toast("error", "WhatsApp Template status update failed");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tableData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.templateName || "N/A"}</td>
                <td>{item?.templateLabel || "N/A"}</td>
                <td>
                  <div className="form-check form-switch d-flex">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={item?.isActive}
                      disabled={loading}
                      onChange={() => handleToggleStatus(item)}
                      style={{
                        backgroundColor: item?.isActive ? "green" : "red",
                      }}
                    />
                  </div>
                </td>
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => goToView(item?.id)}
                  >
                    <BsArrowRightShort className="me-1" />
                    View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default WhatsAppTemplateSettingTable;
